export default "__VITE_ASSET__ca05a1b8__"